import { useEffect, useRef } from "react";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;

const TeamManagement = () => {

    const table1 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
        };
    }, []);


    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Teams Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Teams Management</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="text-end mb-3">
                        <Link to="/create-team" style={{ width: 'fit-content' }} className="d-flex align-items-center btn btn-primary font-18 ms-auto">
                            <span>Create Team </span><i className="bx bx-plus ms-1" />
                        </Link>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div className="tab-content py-3">
                                <div className="tab-pane fade show active" id="primaryhome" role="tabpanel">
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table1} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Logo</th>
                                                    <th>Team Name</th>
                                                    <th>Coach</th>
                                                    <th>Age Group</th>
                                                    <th>Country</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <img src="images/team/t1.jpg" className="team_img" alt />
                                                    </td>
                                                    <td>Team A</td>
                                                    <td>Michael Anderson</td>
                                                    <td>U-17</td>
                                                    <td>USA</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/team-management-detail">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#edit_modal" title="Edit">
                                                                    <i className="bx bx-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#delete_modal" title="Delete">
                                                                    <i className="bx bx-trash" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <img src="images/team/t1.jpg" className="team_img" alt />
                                                    </td>
                                                    <td>Team B</td>
                                                    <td>David Thompson</td>
                                                    <td>U-18</td>
                                                    <td>UK</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/team-management-detail">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#edit_modal" title="Edit">
                                                                    <i className="bx bx-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#delete_modal" title="Delete">
                                                                    <i className="bx bx-trash" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <img src="images/team/t1.jpg" className="team_img" alt />
                                                    </td>
                                                    <td>Team C</td>
                                                    <td>James Parker</td>
                                                    <td>U-15</td>
                                                    <td>USA</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/team-management-detail">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#edit_modal" title="Edit">
                                                                    <i className="bx bx-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#delete_modal" title="Delete">
                                                                    <i className="bx bx-trash" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <img src="images/team/t1.jpg" className="team_img" alt />
                                                    </td>
                                                    <td>Team D</td>
                                                    <td>Robert Collins</td>
                                                    <td>U-14</td>
                                                    <td>USA</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/team-management-detail">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#edit_modal" title="Edit">
                                                                    <i className="bx bx-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#delete_modal" title="Delete">
                                                                    <i className="bx bx-trash" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="edit_modal" tabIndex={-1} aria-labelledby="editTeamModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editTeamModalLabel">Edit Team</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Team Name</label>
                                        <input type="text" className="form-control" defaultValue="Team A" />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Age Group</label>
                                        <select className="form-select" name="agegroup">
                                            <option value="U-11">U-11</option>
                                            <option value="U-12">U-12</option>
                                            <option value="U-13">U-13</option>
                                            <option value="U-14">U-14</option>
                                            <option value="U-15">U-15</option>
                                            <option value="U-16">U-16</option>
                                            <option value="U-17" selected>U-17</option>
                                        </select>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Player Count</label>
                                        <input type="text" className="form-control" defaultValue={23} />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Country</label>
                                        <input type="text" className="form-control" defaultValue="USA" />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="delete_modal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to delete this team?</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default TeamManagement